document.addEventListener("DOMContentLoaded", function() {
  const faqItems = document.querySelectorAll(".faq__item");

  faqItems.forEach(item => {
    const btn = item.querySelector(".faq__question");
    btn.addEventListener("click", () => {
      const isActive = item.classList.contains("active");

      faqItems.forEach(i => i.classList.remove("active"));

      if (!isActive) {
        item.classList.add("active");
      }
    });
  });
});
